import './NavSidebar.css'
import React, { useContext, useState } from 'react'
import { Link, useRouteMatch } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { AppContext } from '../../index'

function getLinkClass(routePath: string, linkPath: string) {
  return routePath === linkPath ? 'current' : 'default'
}

export function NavSidebar() {
  const { state } = useContext(AppContext)
  const partnerId  = state.partner.currentPartner ? state.partner.currentPartner.id : undefined
  const path = useRouteMatch().path
  const [navMenuOpen, setNavMenuOpen] = useState(false)

  function closeMenu() {
    setNavMenuOpen(false)
  }

  const { t } = useTranslation(['navigation'])

  return (
    <nav id="nav-sidebar">
      <div id="logo">
        <img onClick={() => setNavMenuOpen(!navMenuOpen)}
              src="https://hub-dev.papertrail.io/apple-touch-icon-precomposed.png" alt="Papertrail"
        />
      </div>
      <ul className={navMenuOpen ? "visible" : ""}>
        <li id="nav-dashboard">
          <Link className={getLinkClass(path, `/partner/${partnerId}`)} to={`/partner/${partnerId}`} onClick={closeMenu}>
            <div className={"menu-icon"}><i className="fas fa-chart-bar big-icon"></i></div>
            <span>{t('dashboard')}</span>
          </Link>
        </li>
        <li id="nav-subscriptions">
          <Link className={getLinkClass(path, `/subscriptions/${partnerId}`)} to={`/partner/${partnerId}/subscriptions`} onClick={closeMenu}>
            <div className={"menu-icon"}><i className="far fa-clone big-icon"></i></div>
            <span>{t('subscriptions')}</span>
          </Link>
        </li>
        <li id="nav-reports">
          <Link className={getLinkClass(path, `/reports/${partnerId}`)} to={`/partner/${partnerId}/reports`} onClick={closeMenu}>
            <div className={"menu-icon"}><i className="far fa-file-alt big-icon"></i></div>
            <span>{t('reports')}</span>
          </Link>
        </li>
      </ul>
    </nav>
  )
}

export default NavSidebar
